@use "../../../styles.scss" as *;

.Title {
  &.black {
    color: $colors-color-black;
  }

  &.green {
    color: $colors-color-green;
  }
}
